module.exports = __webpack_public_path__ + "img/icon1.bc7bcf96.jpg";